import $ from 'jquery';
import { Lang, translate } from './translate';

$(() => {
  $('.header-menu-toggle').on('click', () => {
    $(window).scrollTop(0);
    $('.header-menu-toggle, .header-menu').toggleClass('show');
  });

  // 言語切替ボタンクリック処理
  $('.trn-lang').on('click', function () {
    const lang = $(this).data('value') as keyof Lang;
    const url = new URL(location.href);

    // クエリ・localStorage言語設定
    url.searchParams.set("lang", lang);
    localStorage.setItem('lang', lang);
    location.href = url.href;
  });
});
